import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import ReactPlayer from 'react-player'
import { getAllActiveSubjects, getSubjectsByCourseId } from './Services/ContentService';
import useQuestionEditorShared from './useQuestionEditorShared';

const TrueFalse = (props) => {
    const { t } = useTranslation()
    const { user } = useAuth();
    const {
        msg, setMsg,
        tags, loadingTags, taglist,
        courses, loadingCourses, courseList,
        urlFile, headersFile,
        executeAction, updateQuestionMedia, handleQuestionMediaChange, handleQuestion
    } = useQuestionEditorShared(props, user);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [tagId, setTagId] = useState([]);
    const [questionType, setQuestionType] = useState([]);
    const [questionMedia, setQuestionMedia] = useState([]);
    const [imagePath, setImagePath] = useState([]);
    const [notfyText, setNotfyText] = useState([]);
    const [loadingSubjects, setLoadingSubjects] = useState(true);
    const [subjects, setSubjects] = useState([]);
    const [data, setData] = useState([]);
    const [subjectId, setSubjectId] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [answerType, setAnswerType] = useState([]);
    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const [multicontentsoundurl, setMulticontentsoundurl] = useState("");

    // Aşağıdaki 6 fonksiyon eskiden birbirinin neredeyse birebir kopyasıydı;
    // ortak yükleme mantığı artık useQuestionEditorShared().handleQuestionMediaChange içinde.
    const handleQuestionPhotoChangeMultiii = (e) =>
        handleQuestionMediaChange(e, "photo", (url) => ({ text: question['text'], type: "image_sound", url, soundUrl: question['url'] }));

    const subjectlist = async () => {
        setLoadingSubjects(true);
        try {
            const activeSubjects = await getAllActiveSubjects(user.token);
            setSubjects(activeSubjects);

            // Mevcut seçili konuyu bulma mantığı
            const currentSubject = activeSubjects.find(s => s.id === props.data.subjectId);
            if (currentSubject) {
                setSubjectId(currentSubject.subjectName);
            }
        } catch (err) {
            setMsg(err.message);
        } finally {
            setLoadingSubjects(false);
        }
    };

    const courseselectchange = async (e) => {
        const selectedCourseId = e.target.value;
        try {
            const filteredSubjects = await getSubjectsByCourseId(selectedCourseId, user.token);
            setSubjects(filteredSubjects); // Mevcut listeyi bu sonuçla değiştirir
        } catch (err) {
            setMsg(err.message);
        }
    };

    const updateTag = async (e) => {
        e.preventDefault();

        // Veriyi hazırlıyoruz
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            tagId: document.getElementById("tagId").value // Sadece tagId'yi güncelle
        };

        executeAction(payload);
    }
    const updateCourse = async (e) => {
        e.preventDefault();
        const selectedSubjectId = document.getElementById("subjectId").value;

        if (!selectedSubjectId) {
            return alert("Subject seçmediniz!");
        }

        const payload = {
            ...props.data,
            subjectId: selectedSubjectId // Sadece subjectId'yi güncelle
        };

        executeAction(payload);
    };
    const handleEdit = async (e) => {
        e.preventDefault();
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            answer: document.getElementById("correctAnswer").value // Sadece answer'ı güncelle
        };
        executeAction(payload);
    }
    const handleQuestionPhotoChangeMulti = (e) =>
        handleQuestionMediaChange(e, "photo", (url) => ({ text: question['text'], type: "image_sound", url, soundUrl: question['soundUrl'] }));

    const handleQuestionSoundChangeMulti = (e) =>
        handleQuestionMediaChange(e, "sound", (url) => ({ text: question['text'], type: "image_sound", url: question['url'], soundUrl: url }));

    const deleteQuestionMediaMulti = async (e) => {
        e.preventDefault();
        if (question['type'] === "image_sound") {
            alert("Hem resim hem ses içeren sorularda medyayı tekli silmek desteklenmemektedir. Her ikisi birden silinir!");
        }
        //let questiontext = document.getElementById("questionText").value;
        var questionnnn = {
            type: "text",
            url: "",
            text: questionTitle + "__" + questionText
        }
        var stringquestion = JSON.stringify(questionnnn)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            notfyText: document.getElementById("infoBoxText").value,
            contentStr: stringquestion,
        };
        executeAction(payload);
    }
    const deleteQuestionMedia = async (e) => {

        e.preventDefault();
        if (question['type'] === "image_sound") {
            alert("Hem resim hem ses içeren sorularda medyayı tekli silmek desteklenmemektedir. Her ikisi birden silinir!");
        }
        var questionnnn = {
            type: "text",
            url: "",
            text: question['text']
        }
        var stringquestion = JSON.stringify(questionnnn)
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            contentStr: stringquestion,
            notfyText: document.getElementById("infoBoxText").value
        };
        executeAction(payload);
    }


    const handleAnswerPhoto = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const { name, value } = e.target;
            const list = [...serviceList];
            list[index]["photo"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index][name] = url;;
                    setServiceList(list);
                    alert("Yüklendi")

                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }
    };
    const handleAnswerVideo = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const { name, value } = e.target;
            const list = [...serviceList];
            list[index]["video"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index]["video"] = url;;
                    setServiceList(list);
                    alert("Yüklendi")
                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };
    const handleAnswerSound = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const { name, value } = e.target;
            const list = [...serviceList];
            list[index]["sound"] = url;
            setServiceList(list);
            updateAnswer();
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    const { name, value } = e.target;
                    const list = [...serviceList];
                    list[index]["sound"] = url;;
                    setServiceList(list);
                    alert("Yüklendi")
                    updateAnswer();
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };

    //----------------------------------------------
    const addPhotoQuestion = (e) =>
        handleQuestionMediaChange(e, "photo", (url) => ({ text: question['text'], type: "image", url }));

    const addVideoQuestion = (e) =>
        handleQuestionMediaChange(e, "video", (url) => ({ text: question['text'], type: "video", url }));

    const addSoundQuestion = (e) =>
        handleQuestionMediaChange(e, "sound", (url) => ({ text: question['text'], type: "sound", url }));

    const handleQuestionPhotoChange = (e) =>
        handleQuestionMediaChange(e, "photo", (url) => ({ text: question['text'], type: "image", url }));

    const handleQuestionVideoChange = (e) =>
        handleQuestionMediaChange(e, "video", (url) => ({ text: question['text'], type: "video", url }));

    const handleQuestionSoundChange = (e) =>
        handleQuestionMediaChange(e, "sound", (url) => ({ text: question['text'], type: "sound", url }));

    const updateAnswer = async (index) => {
        if (index !== undefined) {
            const list = [...serviceList];
            list[index]["service"] = document.getElementById(index + ".service").value;
            setServiceList(list);
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail
            };
            executeAction(payload);
        }
        else {
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail
            };
            executeAction(payload);
        }

    }
    const removeAnswer = async (index) => {
        serviceList.splice(index, 1);
        setServiceList(serviceList);
        var detail = JSON.stringify(serviceList);
        const payload = {
            ...props.data, // Mevcut tüm veriyi kopyala
            detail: detail
        };
        executeAction(payload);

    }
    const addAnswer = async (e, index) => {
        e.preventDefault();
        if (document.getElementById("addedservice").value) {
            const obj = {
                service: document.getElementById("addedservice").value,
            }
            serviceList.push(obj)
            setServiceList(serviceList)
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail
            };
            executeAction(payload);

        }
        else {
            var detail = JSON.stringify(serviceList)
            const payload = {
                ...props.data, // Mevcut tüm veriyi kopyala
                detail: detail
            };
            executeAction(payload);
        }

    }

    useEffect(() => {
        taglist();
        courseList();
        subjectlist();
        setTagId(JSON.parse(props.data.tagId));
        setNotfyText(props.data.notfyText)
        setQuestion(JSON.parse(props.data.contentStr));
        setAnswers(JSON.parse(props.data.detail));
        setAnswer(props.data.answer);
        console.log(props.data.detail)
        if (JSON.parse(props.data.detail)[0]['photo']) {
            setAnswerType("photo");
        }
        else if (JSON.parse(props.data.detail)[0]['video']) {
            setAnswerType("video");
        }
        else if (JSON.parse(props.data.detail)[0]['sound']) {
            setAnswerType("video");
        }
        else {
            setAnswerType("text");
        }
        let questionn = JSON.parse(props.data.contentStr)
        var questionTitlee = questionn['text'].split('__')[0];
        let questionTextt = questionn['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        if (questionn.type === "text") {
            setQuestionType("bos");
        }
        else if (questionn.type === "image_sound") {
            setQuestionType(questionn.type);
            setMulticontentsoundurl(questionn.soundUrl);
            setQuestionMedia(questionn.url);
        }
        else {
            setQuestionType(questionn.type);
            setQuestionMedia(questionn.url);
        }
        setServiceList(JSON.parse(props.data.detail))

    }, []);
    return (
        <div>
            <br />
            <div>
                <h4>True False Sorusu</h4>
                <br />
                <h5>Uyarı: Her Kısımda Güncelle butonu mevcuttur. ilgili alanda yaptığınız değişiklik sonrası güncelleme yapınız lütfen.</h5>

                <h6>{msg}</h6>
            </div>
            <br />
            <form onSubmit={updateTag}>
                {loadingTags && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loadingTags && (
                    <div className='row' style={{ border: "1px solid black", padding: "10px" }}>
                        <div class="col-9">
                            <label for="tagId" class="form-label">{t("selecttag")}</label>
                            <select id="tagId" class="form-select" aria-label="Default select example">
                                {tags ? (
                                    tags && tags.map((dt) => {
                                        if (dt.id === tagId) {
                                            return (
                                                <option value={dt.id} selected>{dt.tagName}</option>
                                            );
                                        }
                                        else {
                                            return (
                                                <option value={dt.id}>{dt.tagName}</option>
                                            );
                                        }
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>
                        <div className='col-3'>
                            <br />
                            <div className='d-flex justify-content-center'>
                                <button type="submit" class="btn btn-primary btn-lg" >{t("update")}</button>
                            </div>
                        </div>

                    </div>

                )}
            </form>
            <br />
            <hr />
            <form onSubmit={updateCourse}>
                <div style={{ border: "1px solid black", padding: "10px" }}>
                    <br />
                    <span>Aktif Subject: {subjectId}</span>
                    {loadingCourses && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                    {!loadingCourses && (
                        <div class="mb-3">
                            <label for="courseId" class="form-label">{t("selectCourse")}</label>
                            <select id="courseId" class="form-select" onChange={courseselectchange}>
                                <option key="" >{t("selectCourse")}</option>

                                {courses ? (
                                    courses && courses.map((dt) => {
                                        return (
                                            <option key={dt.id} value={dt.id}>{dt.courseName} -- {dt.courseDesc}</option>
                                        );
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>
                    )}

                    {loadingSubjects && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                    {!loadingSubjects && (
                        <div class="mb-3">
                            <label for="subjectId" class="form-label">{t("selectSubject")}</label>
                            <select id="subjectId" class="form-select">
                                <option key="" >{t("selectSubject")}</option>

                                {subjects ? (
                                    subjects && subjects.map((dt) => {


                                        if (dt.id === data.subjectId) {
                                            return (
                                                <option value={dt.id} selected>{dt.subjectName}  // {dt.subjectDesc}</option>
                                            );
                                        }
                                        else {
                                            return (
                                                <option value={dt.id}>{dt.subjectName}  // {dt.subjectDesc}</option>
                                            );
                                        }
                                    })
                                ) : (
                                    <p>{t("reloadWarning")}</p>
                                )
                                }
                            </select>
                        </div>

                    )}
                    <div className='d-flex justify-content-center'>
                        <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                    </div>
                </div>
            </form>
            <hr />
            <form onSubmit={handleQuestion} >

                {questionType !== 'bos' &&
                    <div style={{ border: "1px solid black", padding: "10px" }}>
                        {questionType === 'image_sound' && <div>
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div>
                                            <div className="d-flex justify-content-center">

                                                <img style={{ width: "40%" }} src={questionMedia}></img>
                                            </div><hr />
                                            <div className="mb-3">
                                                <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                                <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChangeMulti} id="addphoto" name="addphoto" />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                                <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChange} id="addphotos" name="addphotos" />
                                            </div>
                                            <br />
                                            <div className='d-flex justify-content-center'>
                                                <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMediaMulti}>Medya {t("delete")}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="d-flex justify-content-center">
                                        <div className='player-wrapper'>
                                            <ReactAudioPlayer
                                                src={multicontentsoundurl}
                                                controls
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="mb-3">
                                        <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                        <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChangeMulti} id="videocontent" name="videocontent" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="addvideos" className="form-label">{t("addSoundbyUrl")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChange} id="addvideos" name="addvideos" />
                                    </div>
                                    <br />
                                    <div className='d-flex justify-content-center'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMediaMulti}>Medya {t("delete")}</button>
                                    </div>
                                </div>

                            </div>
                            <hr />

                        </div>}

                        {questionType === 'image' && <div>
                            <div className="row" style={{ border: "1px solid", padding: "1%" }}>
                                <div className='col'>
                                    <img style={{ width: "40%" }} src={questionMedia}></img>
                                    <div>
                                        <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                        <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChange} id="addphoto" name="addphoto" />
                                    </div>
                                    <div>
                                        <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChange} id="addphotos" name="addphotos" />
                                    </div>
                                    <br />   <br />   <br />
                                    <div className='d-flex justify-content-center'>
                                        <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className="mb-3">
                                        <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                        <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChangeMulti} id="videocontent" name="videocontent" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="addvideos" className="form-label">{t("addSound")}</label>
                                        <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChangeMulti} id="addvideos" name="addvideos" />
                                    </div>
                                </div>
                            </div>
                            <br />

                            <hr />
                        </div>}
                        {questionType === 'video' && <div>
                            <div class="d-flex justify-content-center">
                                <div className='player-wrapper'>
                                    <ReactPlayer
                                        className='react-player'
                                        url={questionMedia}
                                        controls={true}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <hr />
                                <div class="mb-3">
                                    <label for="videocontent" class="form-label">{t("addVideo")}</label>
                                    <input class="form-control" type="file" accept='video' onChange={handleQuestionVideoChange} id="videocontent" name="videocontent" />
                                </div>
                                <div class="mb-3">
                                    <label for="addvideos" class="form-label">{t("addVideobyUrl")}</label>
                                    <textarea class="form-control" rows={1} type="text" onChange={handleQuestionVideoChange} id="addvideos" name="addvideos" />
                                </div>
                            </div>
                            <br />
                            <form onSubmit={deleteQuestionMedia}>
                                <div className='d-flex justify-content-center'>
                                    <button type="submit" class="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                </div>
                            </form>
                        </div>}
                        {questionType === 'sound' && <div className='row' style={{ border: "1px solid", padding: "1%" }}>
                            <div className='col'>
                                <b>sadece ses dosyası vardır</b>
                                <div>
                                    <label htmlFor="addphoto" className="form-label">{t("addPhoto")}</label>
                                    <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleQuestionPhotoChangeMultiii} id="addphoto" name="addphoto" />
                                </div>
                                <div>
                                    <label htmlFor="addphotos" className="form-label">{t("addPhotobyUrl")}</label>
                                    <textarea className="form-control" rows={1} type="text" onChange={handleQuestionPhotoChangeMultiii} id="addphotos" name="addphotos" />
                                </div>
                                <br />   <br />   <br />
                                <div className='d-flex justify-content-center'>
                                    <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                </div>
                            </div>
                            <div className='col'>
                                <div className="d-flex justify-content-center">
                                    <div className='player-wrapper'>
                                        <ReactAudioPlayer
                                            src={questionMedia}
                                            controls
                                        />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="videocontent" className="form-label">{t("addSound")}</label>
                                    <input className="form-control" type="file" accept='audio/*' onChange={handleQuestionSoundChange} id="videocontent" name="videocontent" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="addvideos" className="form-label">{t("addSoundbyUrl")}</label>
                                    <textarea className="form-control" rows={1} type="text" onChange={handleQuestionSoundChange} id="addvideos" name="addvideos" />
                                </div>
                                <br />
                                <div className='d-flex justify-content-center'>
                                    <button type="button" className="btn btn-danger btn-lg" onClick={deleteQuestionMedia}>Medya {t("delete")}</button>
                                </div>
                            </div>
                        </div>}
                    </div>
                }
                <br />
                {questionType === 'bos' && <div>
                    <h4>soru başlığında medya bulunmamaktadır. Eklemek İçin:</h4>
                    <div class="accordion accordion-flush" id="accordionFlushExample" style={{ backgroundColor: "gray" }}>
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                    <h4>{t('addFile')}</h4> <i>video ve resimler için minumum 1280*720 önerilir.</i>
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{ backgroundColor: "white" }}>
                                <div className="row" style={{ padding: "1%" }}>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="addphoto" class="form-label">{t("addPhoto")}</label>
                                            <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={addPhotoQuestion} id="addphoto" name="addphoto" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="addphotos" class="form-label">{t("addPhotobyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={addPhotoQuestion} id="addphotos" name="addphotos" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="addvideo" class="form-label">{t("addVideo")}</label>
                                            <input class="form-control" type="file" accept='video' onChange={addVideoQuestion} id="addvideo" name="addvideo" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="addvideos" class="form-label">{t("addVideobyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={addVideoQuestion} id="addvideos" name="addvideos" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="addsound" class="form-label">{t("addSound")}</label>
                                            <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={addSoundQuestion} id="addsound" name="addsound" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="addsounds" class="form-label">{t("addSoundbyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={addSoundQuestion} id="addsounds" name="addsounds" />
                                        </div>
                                    </div>


                                </div>
                                <br />
                            </div>

                        </div>
                        <br />

                    </div>
                </div>}
                <br />
                <div style={{ border: "1px solid black", padding: "10px" }}>
                    <div class="mb-3">
                        <label for="infoBoxText" class="form-label">{t("infoBoxText")}</label> <br />
                        <textarea class="form-control" id="infoBoxText" defaultValue={notfyText} />
                    </div>

                    <div class="mb-3">
                        <label for="questionTitle" class="form-label">{t("questionTitle")}</label><br />
                        <textarea class="form-control" id="questionTitle" defaultValue={questionTitle} />
                    </div>
                    <div class="mb-3">
                        <label for="questionText" class="form-label">{t("questionText")}</label><br />
                        <textarea class="form-control" id="questionText" defaultValue={questionText} />
                    </div>

                </div>
                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg" onClick={handleQuestion}>{t("update")}</button>
                </div>
            </form>
            <br />
            <hr />
            <form onSubmit={handleEdit} style={{ border: "1px solid black", padding: "10px" }}>

                <div class="mb-3">
                    <label for="correctAnswer" class="form-label">{t("correctAnswer")}</label><br /><i>Lütfen küçük harfler ile boşluksuz virgüllü yazınız. örn cevap: true,false,true. cevap ekle kısmında eklenen her soru/ifade nin cevapları şeklinde olmalıdır </i>
                    <textarea class="form-control" id="correctAnswer" defaultValue={answer} />
                </div>
                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                </div>
            </form>
            <br />
            <hr />

            <div class="d-flex justify-content-center" style={{ border: "1px solid black", fontSize: 20, textAlign: "center" }}>
                <form>
                    {answers.map((singleService, index) => (
                        <div key={index} className="services">
                            <h1>Cevap : {index + 1}</h1>
                            <div className="first-division">
                                <div className="row" style={{ padding: "1%" }}>
                                    <div style={{ alignContent: "center", textAlign: "center", padding: "2%" }}>
                                        <h5>Cevap Medya Dosyası</h5>
                                        <br />
                                        {singleService['photo'] &&
                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <img src={singleService['photo']} />
                                                </div>
                                                <div className="col-md-4">
                                                    <div class="mb-1">
                                                        <label for="photo" class="form-label">{t("addPhoto")}</label> <i>1:1 oranında 566*566 pixel ve üzeri </i>
                                                        <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAnswerPhoto(e, index)} id="photo" name="photo" required />
                                                    </div>
                                                    <div class="mb-1">
                                                        <label for="photoUrl" class="form-label">{t("addPhotobyUrl")}</label>
                                                        <textarea class="form-control" rows={2} type="text" onChange={(e) => handleAnswerPhoto(e, index)} id="photourl" name="photoUrl" />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {singleService['video'] &&
                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <ReactPlayer
                                                        className='react-player'
                                                        url={singleService['video']}
                                                        controls={true}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <div class="mb-1">
                                                        <label for="video" class="form-label">{t("addVideo")}</label> <i>1:1 oranında </i>
                                                        <input class="form-control" type="file" accept='video' onChange={(e) => handleAnswerVideo(e, index)} id="video" name="video" required />
                                                    </div>
                                                    <div class="mb-1">
                                                        <label for="videoUrl" class="form-label">{t("addVideobyUrl")}</label>
                                                        <textarea class="form-control" rows={2} type="text" onChange={(e) => handleAnswerVideo(e, index)} id="videoUrl" name="videoUrl" />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {singleService['sound'] &&
                                            <div className='row'>
                                                <div className="col-md-8">

                                                    <ReactAudioPlayer
                                                        src={singleService['sound']}
                                                        autoPlay
                                                        controls
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <div class="mb-1">
                                                        <label for="sound" class="form-label">{t("addSound")}</label>
                                                        <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAnswerSound(e, index)} id="sound" name="sound" required />
                                                    </div>
                                                    <div class="mb-1">
                                                        <label for="soundUrl" class="form-label">{t("addSoundbyUrl")}</label>
                                                        <textarea class="form-control" rows={2} type="text" onChange={(e) => handleAnswerSound(e, index)} id="soundUrl" name="soundUrl" />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {!singleService['sound'] && !singleService['photo'] && !singleService['video'] &&
                                            <div>
                                                cevapta medya bulunmamaktadır.
                                            </div>
                                        }
                                        <hr />
                                    </div>
                                </div>

                                <div>
                                    <h6 for="service" class="form-label">{t("answerText")}</h6><i>boş ise 1 ader boşluk giriniz. (sadece video/resim/ses var ise)</i> <i>{props.infoText}</i>
                                    <textarea class="form-control" name="service" id={index + ".service"} defaultValue={singleService['service']} required />
                                </div>
                            </div>
                            <div className="second-division">
                                <button
                                    type="button"
                                    id={index}
                                    onClick={() => updateAnswer(index)}
                                    className="remove-btn btn btn-info"
                                >
                                    <span>Cevabı Güncelle</span>
                                </button>
                                &nbsp;
                                {answers.length !== 1 && (
                                    <button
                                        type="button"
                                        onClick={() => removeAnswer(index)}
                                        className="remove-btn btn btn-danger"
                                    >
                                        <span>Cevabı Kaldır</span>
                                    </button>
                                )}
                            </div>
                            <hr />
                        </div>
                    ))}

                </form>
            </div>
            <hr />
            {answers.length < 6 && (
                <div style={{ border: "1px solid black", padding: "2%" }}>
                    <h3>Cevap Ekle</h3>
                    <form onSubmit={addAnswer}>
                        <div className="services">
                            <div className="first-division">

                                <div>
                                    <h6 for="service" class="form-label">{t("answerText")}</h6><i>boş ise 1 ader boşluk giriniz. (sadece video/resim/ses var ise)</i> <i>{props.infoText}</i>
                                    <textarea class="form-control" name="service" id="addedservice" required />
                                    <hr />
                                    <button className='btn btn-info' id="" onClick={addAnswer}>{t('save')}</button>
                                </div>

                                <br />
                                <br />

                            </div>

                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default TrueFalse;